"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.merklSubgraphALMEndpoints = exports.merklSubgraphAMMEndpoints = exports.getMerklSubgraphPrefix = exports.merklFallbackTGEndpoint = exports.swapsSubgraphsEndpoint = void 0;
const constants_1 = require("../../types/constants");
const merkl_1 = require("../../types/merkl");
const sushiswapV3SubgraphPrefix = 'https://api.thegraph.com/subgraphs/name/sushi-v3/v3-';
exports.swapsSubgraphsEndpoint = {
    [constants_1.ChainId.ARBITRUM]: {
        [merkl_1.AMMType.SushiSwapV3]: sushiswapV3SubgraphPrefix + 'arbitrum',
        [merkl_1.AMMType.UniswapV3]: 'https://api.thegraph.com/subgraphs/name/ianlapham/arbitrum-minimal',
    },
    [constants_1.ChainId.MAINNET]: {
        [merkl_1.AMMType.SushiSwapV3]: sushiswapV3SubgraphPrefix + 'ethereum',
        [merkl_1.AMMType.UniswapV3]: 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v3',
        [merkl_1.AMMType.PancakeSwap]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-eth',
    },
    [constants_1.ChainId.OPTIMISM]: {
        [merkl_1.AMMType.SushiSwapV3]: sushiswapV3SubgraphPrefix + 'optimism',
        [merkl_1.AMMType.UniswapV3]: 'https://api.thegraph.com/subgraphs/name/ianlapham/optimism-post-regenesis',
    },
    [constants_1.ChainId.POLYGON]: {
        [merkl_1.AMMType.SushiSwapV3]: sushiswapV3SubgraphPrefix + 'polygon',
        [merkl_1.AMMType.UniswapV3]: 'https://api.thegraph.com/subgraphs/name/ianlapham/uniswap-v3-polygon',
        [merkl_1.AMMType.Retro]: 'https://api.thegraph.com/subgraphs/name/ruvlol/univ3-test',
    },
    [constants_1.ChainId.POLYGONZKEVM]: { [merkl_1.AMMType.PancakeSwap]: 'https://api.studio.thegraph.com/query/45376/exchange-v3-polygon-zkevm/version/latest' },
};
const merklFallbackSubgraphPrefix = 'https://api.thegraph.com/subgraphs/name/anglekeeper/backup-';
const merklFallbackSubgraphPrefixUniswapV3 = `${merklFallbackSubgraphPrefix}uniswapv3-`;
const merklFallbackSubgraphPrefixSushiswapV3 = `${merklFallbackSubgraphPrefix}sushiswapv3-`;
const merklFallbackSubgraphPrefixRetro = `${merklFallbackSubgraphPrefix}retro-`;
exports.merklFallbackTGEndpoint = {
    [constants_1.ChainId.ARBITRUM]: {
        [merkl_1.AMMType.Retro]: merklFallbackSubgraphPrefixRetro + 'arbitrum',
        [merkl_1.AMMType.SushiSwapV3]: merklFallbackSubgraphPrefixSushiswapV3 + 'arbitrum',
        [merkl_1.AMMType.UniswapV3]: merklFallbackSubgraphPrefixUniswapV3 + 'arbitrum',
    },
    [constants_1.ChainId.MAINNET]: {
        [merkl_1.AMMType.Retro]: merklFallbackSubgraphPrefixRetro + 'ethereum',
        [merkl_1.AMMType.SushiSwapV3]: merklFallbackSubgraphPrefixSushiswapV3 + 'ethereum',
        [merkl_1.AMMType.UniswapV3]: merklFallbackSubgraphPrefixUniswapV3 + 'ethereum',
        [merkl_1.AMMType.PancakeSwap]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-eth',
    },
    [constants_1.ChainId.OPTIMISM]: {
        [merkl_1.AMMType.Retro]: merklFallbackSubgraphPrefixRetro + 'optimism',
        [merkl_1.AMMType.SushiSwapV3]: merklFallbackSubgraphPrefixSushiswapV3 + 'optimism',
        [merkl_1.AMMType.UniswapV3]: merklFallbackSubgraphPrefixUniswapV3 + 'optimism',
    },
    [constants_1.ChainId.POLYGON]: {
        [merkl_1.AMMType.Retro]: merklFallbackSubgraphPrefixRetro + 'polygon',
        [merkl_1.AMMType.SushiSwapV3]: merklFallbackSubgraphPrefixSushiswapV3 + 'polygon',
        [merkl_1.AMMType.UniswapV3]: merklFallbackSubgraphPrefixUniswapV3 + 'polygon',
    },
    [constants_1.ChainId.POLYGONZKEVM]: { [merkl_1.AMMType.PancakeSwap]: 'https://api.studio.thegraph.com/query/45376/exchange-v3-polygon-zkevm/version/latest' },
};
const merklSubgraphPrefix = 'https://api.thegraph.com/subgraphs/name/angleprotocol/';
const merklSubgraphPrefixStudio = 'https://api.studio.thegraph.com/query/12694/';
const getMerklSubgraphPrefix = (env, isStudio = false) => {
    return isStudio
        ? merklSubgraphPrefixStudio + (env !== 'prod' ? 'test-merkl-' : 'merkl-')
        : merklSubgraphPrefix + (env !== 'prod' ? 'test-merkl-' : 'merkl-');
};
exports.getMerklSubgraphPrefix = getMerklSubgraphPrefix;
const merklSubgraphAMMEndpoints = (env) => {
    return {
        [constants_1.ChainId.ARBITRUM]: {
            [merkl_1.AMMType.SushiSwapV3]: (0, exports.getMerklSubgraphPrefix)(env) + 'sushiswapv3-arb',
            [merkl_1.AMMType.UniswapV3]: (0, exports.getMerklSubgraphPrefix)(env) + 'uniswapv3-arb',
        },
        [constants_1.ChainId.MAINNET]: {
            [merkl_1.AMMType.SushiSwapV3]: (0, exports.getMerklSubgraphPrefix)(env) + 'sushiswapv3-eth',
            [merkl_1.AMMType.UniswapV3]: (0, exports.getMerklSubgraphPrefix)(env) + 'uniswapv3-eth',
            [merkl_1.AMMType.PancakeSwap]: (0, exports.getMerklSubgraphPrefix)(env) + 'pancakeswapv3-eth',
        },
        [constants_1.ChainId.OPTIMISM]: {
            [merkl_1.AMMType.SushiSwapV3]: (0, exports.getMerklSubgraphPrefix)(env) + 'sushiswapv3-opt',
            [merkl_1.AMMType.UniswapV3]: (0, exports.getMerklSubgraphPrefix)(env) + 'uniswapv3-opt',
        },
        [constants_1.ChainId.POLYGON]: {
            [merkl_1.AMMType.Retro]: (0, exports.getMerklSubgraphPrefix)(env) + 'retro-pol',
            [merkl_1.AMMType.SushiSwapV3]: (0, exports.getMerklSubgraphPrefix)(env) + 'sushiswapv3-pol',
            [merkl_1.AMMType.UniswapV3]: (0, exports.getMerklSubgraphPrefix)(env) + 'uniswapv3-pol',
        },
        [constants_1.ChainId.POLYGONZKEVM]: {
            [merkl_1.AMMType.PancakeSwap]: (0, exports.getMerklSubgraphPrefix)(env, true) + 'pancakeswapv3-zkevm/version/latest',
        },
    };
};
exports.merklSubgraphAMMEndpoints = merklSubgraphAMMEndpoints;
const merklSubgraphALMEndpoints = (env) => {
    return {
        [constants_1.ChainId.ARBITRUM]: {
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Arrakis]: (0, exports.getMerklSubgraphPrefix)(env) + 'arrakis-arb',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Gamma]: (0, exports.getMerklSubgraphPrefix)(env) + 'gamma-arb',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].DefiEdge]: (0, exports.getMerklSubgraphPrefix)(env) + 'defiedge-arb',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Steer]: (0, exports.getMerklSubgraphPrefix)(env) + 'steer-arb',
        },
        [constants_1.ChainId.MAINNET]: {
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Arrakis]: (0, exports.getMerklSubgraphPrefix)(env) + 'arrakis-eth',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Gamma]: (0, exports.getMerklSubgraphPrefix)(env) + 'gamma-eth',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].DefiEdge]: (0, exports.getMerklSubgraphPrefix)(env) + 'defiedge-eth',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Ichi]: (0, exports.getMerklSubgraphPrefix)(env) + 'ichi-eth',
        },
        [constants_1.ChainId.OPTIMISM]: {
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Arrakis]: (0, exports.getMerklSubgraphPrefix)(env) + 'arrakis-opt',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Gamma]: (0, exports.getMerklSubgraphPrefix)(env) + 'gamma-opt',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].DefiEdge]: (0, exports.getMerklSubgraphPrefix)(env) + 'defiedge-opt',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Steer]: (0, exports.getMerklSubgraphPrefix)(env) + 'steer-opt',
        },
        [constants_1.ChainId.POLYGON]: {
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Arrakis]: (0, exports.getMerklSubgraphPrefix)(env) + 'arrakis-pol',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Gamma]: (0, exports.getMerklSubgraphPrefix)(env) + 'gamma-pol',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].DefiEdge]: (0, exports.getMerklSubgraphPrefix)(env) + 'defiedge-pol',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Ichi]: (0, exports.getMerklSubgraphPrefix)(env) + 'ichi-pol',
            [merkl_1.Wrapper[merkl_1.AMMType.UniswapV3].Steer]: (0, exports.getMerklSubgraphPrefix)(env) + 'steer-pol',
        },
        [constants_1.ChainId.POLYGONZKEVM]: {},
    };
};
exports.merklSubgraphALMEndpoints = merklSubgraphALMEndpoints;
//# sourceMappingURL=endpoints.js.map